const TeslaRoute = [
  {
    path: '/tesla',
    component: () => import('../pages/tesla/'),
    children: [
      {
        path: 'examine-sql-detail',
        name: 'examine-sql-detail',
        component: () => import('../pages/tesla/examine-sql-detail.vue'),
        meta: {
          title: '业务系统研发部',
        },
      },
    ],
  },
];

export default TeslaRoute;
